import { render, staticRenderFns } from "./DemoButton.vue?vue&type=template&id=97469de8&scoped=true&"
import script from "./DemoButton.vue?vue&type=script&lang=js&"
export * from "./DemoButton.vue?vue&type=script&lang=js&"
import style0 from "./DemoButton.vue?vue&type=style&index=0&id=97469de8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97469de8",
  null
  
)

export default component.exports